

export function isEmpty(value: string | Array<any> | null | undefined) {
    if (Array.isArray(value)) {
        return value.length === 0;
    } else {
        return value === '' || value == null || false;
    }
}


/**
 * Tagged template function for excluding undefined or null values.
 *
 * from:  https://stackoverflow.com/questions/33574281/nicer-way-to-optionally-include-string-in-es6-string-template
 */
export function nonEmpty(parts: Array<string>) {
    let res = parts[0];
    for (let i=1; i<parts.length; i++) {
        if (arguments[i]) // you might want to handle `0` different
            res += arguments[i];
        res += parts[i];
    }
    return res;
}
